import React from "react";

import "./footerup.scss";

const footerup = () => {
  return (
    <div className="footerup">
      <div className="containerfooter">
        <div className="desk1">
          <h1>Visit Us!</h1>
          <div className="alamat">
            Sinar Mas Land Plaza Jl. Grand Boulevard BSD City, Sampora, Kec.
            Cisauk, Kabupaten Tangerang, Banten 15345
          </div>
        </div>
        <hr />
        <div className="desk2">
          Dapatkan Informasi Promo, Brosur dan Pricelist Terbaru
        </div>
        <hr />
        <div className="desk3">Contact Us: +6282172727291 (Swandy)</div>
      </div>

      <a href="/privacy-policy">Privacy Policy </a>
      <div className="copyright">
        © All Rights Reserved, Ruko Komersial BSD & Gading Serpong
      </div>
      <div className="powered">Powered by Linktown</div>
    </div>
  );
};

export default footerup;
